import Modal from '~/javascripts/components/Modal';
import t from '~/javascripts/utils/translation';

const RedirectModal = ({
  campaignName,
  campaignUrl,
  daysLeft,
  userAvatarImageUrl,
  userName,
}) => (
  <>
    <Modal
      autoOpen={true}
      containerClassName='theme-design-system-v1'
      modalId='campaign-redirect-modal'
      modalInnerClassName='md-rounded-lg text-align-center'
    >
      <div className='px-3'>
        <div
          className='mt-5 mb-3'
          dangerouslySetInnerHTML={{ __html: userAvatarImageUrl }}
        />
        <h1 className='heading-l mb-2'>{campaignName}</h1>
        <p
          className='mb-5'
          dangerouslySetInnerHTML={{
            __html: t('views.campaigns.campaign_redirect_text', {
              user_name: userName,
            }),
          }}
        />
        <a
          className='button button--cw-yellow button--expand text-cw-black mb-3'
          href={campaignUrl}
          style={{
            width: '50%',
          }}
        >
          Give Today
        </a>
        <p className='body-2xs italic'>{daysLeft} days left to give</p>
      </div>
    </Modal>
  </>
);

export default RedirectModal;
